import { render, staticRenderFns } from "./MetadataRequestAssetDetails.vue?vue&type=template&id=2c6a223a&scoped=true"
import script from "./MetadataRequestAssetDetails.vue?vue&type=script&lang=js"
export * from "./MetadataRequestAssetDetails.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./MetadataRequestAssetDetails.vue?vue&type=style&index=1&id=2c6a223a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c6a223a",
  null
  
)

export default component.exports